import { Toast } from "vant";
import {
  resInterceptors,
  reqInterceptors,
  resErrInterceptors
} from "./interceptors";
import axios from "axios";
const service = axios.create({
  timeout: 50000,
  withCredentials: true
});
service.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8";
service.defaults.headers.post["Cache-Control"] = "no-cache";
service.interceptors.request.use(
  config => {
    Toast.loading({
      message: "加载中...",
      forbidClick: true,
      duration: 3000
    });
    if (!config.url.includes("getXgtToken")) {
      config.headers.token = sessionStorage.getItem("Token");
    }
    if (
      sessionStorage.getItem("ifSelect") == 1 &&
      process.env.NODE_ENV === "production"
    ) {
      if("1" ==  window.__config__.LOGIN_TYPE){
        $.ajax({
          url: 'serverconfig.json',
          async: false,
          type: 'get',
          dataType: "json",
          success: function (rs) {
              CONFIG = rs
              //H5
              if(rs.ApiUrl && rs.SelectUrl){
                  sessionStorage.setItem('isConfig',1)
                  service.defaults.baseURL = rs.ApiUrl
                  sessionStorage.setItem('SelectUrl',rs.SelectUrl)
              }
          }
        });
      }else{
        config.baseURL = sessionStorage.getItem("SelectUrl");
      }
    }
    if (sessionStorage.getItem("schoolCode") == "10209"){
      config.headers.post["Token-Digest"] = "e70762befb2da354d4cd05e3e59fd8ce";
    }
    return reqInterceptors(config);
  },
  error => {
    Toast.loading({
      message: "请求出错",
      forbidClick: true,
      duration: 2500
    });
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  response => {
    if (response.status === 200) {
      Toast.clear();
      if (response.data.code === "0") {
        setTimeout(() => {
          Toast({
            message: response.data.Msg || response.data.msg,
            forbidClick: true,
            duration: 1500
          });
        }, 500);
      }else if(response.data.code === "401"){
        //token失效
        sessionStorage.removeItem("Token");
        this.$router.replace("/login");
      }
      return resInterceptors(response);
    } else {
      return Promise.reject(resErrInterceptors(error));
    }
  },
  error => {
    Toast.loading({
      message: "服务器错误",
      forbidClick: true,
      duration: 3000
    });
    // console.log(error);
    return Promise.reject();
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js